// extracted by mini-css-extract-plugin
export default {"App":"EledoPageLoader_App__eLGLp","Loader":"EledoPageLoader_Loader__yxesb","LoaderImage":"EledoPageLoader_LoaderImage__adRtc"};